export const SITE = {
  name: "抖漫",
  slogan: "聚合短剧化动态漫画，竖屏全屏有声在线看",
  description:
    "抖漫聚合短剧化动态漫画，竖屏全屏观看更沉浸，自带配音与特效，追更不迷路。想看抖漫短剧、抖漫动态漫画，点开即看，热门作品持续更新。",
  keywords: "抖漫,抖漫短剧,抖漫动态漫画,抖漫竖屏,抖漫全屏,抖漫有声,抖漫特效",
  baseUrl: "https://dyshorts.github.io",
  email: "contact@douman.app",
  phone: "400-888-6666",
  address: "中国北京市朝阳区抖漫科技园区 A 座",
};